import { defineTool } from '@/shell/tool';

/** Marketing Factory: Vibes' factory in a frame (Flutter's `marketing` embed). */
export default defineTool({
  id: 'vibes-marketing',
  title: 'Marketing Factory',
  summary: "Vibes' marketing factory, in a frame.",
  section: 'vibes',
  order: 60,
  icon: 'campaign',
  owner: '@Drabu',
  permission: 'vibes-marketing:use',
  routes: () => import('./MarketingPage'),
});
